import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield, FileText, X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-brand-slate-900 text-brand-slate-400 py-12 px-4 border-t border-brand-slate-800" data-id="element-47">
        <div className="max-w-4xl mx-auto" data-id="element-48">
          <div className="flex flex-col items-center text-center space-y-6" data-id="element-49">
            {/* Copyright */}
            <div data-id="element-50">
              <p className="text-sm font-medium text-brand-slate-300" data-id="element-51">
                © 2026 Sistema Freezer Fit - Vitalia Guides
              </p>
              <p className="text-xs mt-2 text-brand-slate-500" data-id="element-52">
                Hecho con ❄️ en Argentina
              </p>
            </div>

            {/* Legal Links */}
            <div className="flex items-center gap-6" data-id="element-53">
              <button onClick={() => setActiveModal('privacy')} className="flex items-center gap-2 text-sm text-brand-slate-400 hover:text-brand-sky transition-colors" style={{
              fontSize: '12px'
            }} data-id="element-54">
                <Shield className="w-4 h-4" data-id="element-55" />
                Política de Privacidad
              </button>
              <span className="text-brand-slate-700" data-id="element-56">•</span>
              <button onClick={() => setActiveModal('terms')} className="flex items-center gap-2 text-sm text-brand-slate-400 hover:text-brand-sky transition-colors" style={{
              fontSize: '12px'
            }} data-id="element-57">
                <FileText className="w-4 h-4" data-id="element-58" />
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Legal Modal */}
      <AnimatePresence data-id="element-59">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brand-slate-900/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-60">
            <motion.div initial={{
          opacity: 0,
          y: 24,
          scale: 0.96
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 24,
          scale: 0.96
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-61">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-5 border-b border-brand-slate-200" data-id="element-62">
                <div className="flex items-center gap-3" data-id="element-63">
                  {activeModal === 'privacy' ? <div className="w-8 h-8 rounded-lg bg-brand-green-light flex items-center justify-center" data-id="element-64">
                      <Shield className="w-4 h-4 text-brand-sky" data-id="element-65" />
                    </div> : <div className="w-8 h-8 rounded-lg bg-brand-green-light flex items-center justify-center" data-id="element-66">
                      <FileText className="w-4 h-4 text-brand-sky" data-id="element-67" />
                    </div>}
                  <h3 className="text-lg font-semibold text-brand-slate-900" data-id="element-68">
                    {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                  </h3>
                </div>
                <button onClick={() => setActiveModal(null)} className="w-8 h-8 rounded-lg flex items-center justify-center text-brand-slate-400 hover:text-brand-slate-600 hover:bg-brand-slate-100 transition-colors" data-id="element-69">
                  <X className="w-5 h-5" data-id="element-70" />
                </button>
              </div>

              {/* Modal Content */}
              <div className="p-5 overflow-y-auto max-h-[calc(80vh-72px)] text-sm text-brand-slate-600 leading-relaxed space-y-4" data-id="element-71">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-72" /> : <TermsContent data-id="element-73" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p data-id="element-74">
        <strong className="text-brand-slate-800" data-id="element-75">
          1. Responsable de los datos:
        </strong>{' '}
        Vitalia Guides es el responsable del tratamiento de los datos personales
        que nos facilites.
      </p>
      <p data-id="element-76">
        <strong className="text-brand-slate-800" data-id="element-77">2. Finalidad:</strong> Usamos
        tus datos para gestionar tu compra, enviarte el material digital y
        mantenerte informado sobre actualizaciones del sistema.
      </p>
      <p data-id="element-78">
        <strong className="text-brand-slate-800" data-id="element-79">3. Tus derechos:</strong> Podés
        acceder, rectificar y suprimir tus datos en cualquier momento
        contactándonos. No compartimos tu información con terceros salvo
        obligación legal.
      </p>
      <p data-id="element-80">
        <strong className="text-brand-slate-800" data-id="element-81">4. Seguridad:</strong>{' '}
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tus datos personales.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p data-id="element-82">
        <strong className="text-brand-slate-800" data-id="element-83">1. Uso personal:</strong> El
        Sistema Freezer Fit es para uso personal y exclusivo del comprador.
        Queda prohibida su distribución, venta o compartición masiva.
      </p>
      <p data-id="element-84">
        <strong className="text-brand-slate-800" data-id="element-85">
          2. Propiedad intelectual:
        </strong>{' '}
        Todo el contenido (recetas, guías) está protegido por derechos de autor
        propiedad de Vitalia Guides.
      </p>
      <p data-id="element-86">
        <strong className="text-brand-slate-800" data-id="element-87">3. Garantía:</strong> Ofrecemos
        una garantía de satisfacción de 7 días. Si no estás conforme, te
        devolvemos el 100% del dinero.
      </p>
      <p data-id="element-88">
        <strong className="text-brand-slate-800" data-id="element-89">4. Responsabilidad:</strong>{' '}
        Vitalia Guides no se hace responsable por el uso indebido de las
        técnicas de conservación. Es responsabilidad del usuario seguir las
        instrucciones de seguridad alimentaria.
      </p>
    </>;
}